const { ATT_POINTS_PER_LEVEL, getAttUpgradeCost } = require('../constants/Balance');
const heroBase = require('../models/game_state/heroes');

const getAvailableAttributePoints = ({ built_hero, roster_hero }) => {
  if (built_hero.hero_handle !== roster_hero.handle) {
    throw new Error('[getAvailableAttributePoints] hero mismatch', { built_hero, roster_hero });
  }

  const base_atts = heroBase[built_hero.hero_handle].getBaseAttributes();

  const total_points = ATT_POINTS_PER_LEVEL * roster_hero.level;
  const total_spent = Object.entries(built_hero.attribute_upgrades)
    .reduce(
      (t, [att_key, num_upgrades]) => {
        for (let i = 0; i < num_upgrades; ++i) {
          t += getAttUpgradeCost(base_atts[att_key] + i);
        }
        return t;
      },
      0,
    );
  return total_points - total_spent;
};
module.exports = getAvailableAttributePoints;
